module.exports = __webpack_public_path__ + "img/home-10.0f1b2175.png";